import { combineReducers } from 'redux';
import auth from './userAuth/user';
import home from './home/home';
import courses from './courses/courses';
import accountSettings from './AccountSettings/AccountSettings';
import subscriptions from './subscription/subscription';

const staticReducers = { auth, home, courses, subscriptions, accountSettings };

function createReducer(asyncReducers: any) {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
}

const rootReducer = createReducer(staticReducers);

export default rootReducer;
